var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 17 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_1507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.69476 1.35878C5.40723 1.35878 5.40723 1.09924 5.40723 0.969468C5.40723 0.839697 5.40723 0.580154 8.69476 0.580154C11.9823 0.580154 11.9823 0.839697 11.9823 0.969468C11.9823 1.09924 11.9823 1.35878 8.69476 1.35878ZM6.27237 0.969468C6.79145 1.01273 7.61333 1.05598 8.69476 1.05598C9.77618 1.05598 10.5981 1.01273 11.1172 0.969468C10.5981 0.926211 9.73293 0.882954 8.69476 0.882954C7.61333 0.882954 6.79145 0.926211 6.27237 0.969468Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71003 2.91603C5.537 2.91603 5.40723 2.78626 5.40723 2.61323V0.926212C5.40723 0.753184 5.537 0.839698 5.71003 0.839698C5.88305 0.839698 6.01282 0.969469 6.01282 1.1425V2.61323C5.96957 2.78626 5.88305 2.91603 5.71003 2.91603Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7227 2.91604C11.5497 2.91604 11.4199 2.78626 11.4199 2.61324V1.18576C11.4199 1.01273 11.5497 0.882956 11.7227 0.882956C11.8957 0.882956 12.0255 0.796443 12.0255 0.969471V2.61324C12.0255 2.78626 11.8957 2.91604 11.7227 2.91604Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8752 6.37659H1.34088C0.908312 6.37659 0.562256 6.03054 0.562256 5.59797V3.3486C0.562256 2.91603 0.908312 2.56998 1.34088 2.56998H15.8752C16.3078 2.56998 16.6539 2.91603 16.6539 3.3486V5.59797C16.6539 6.03054 16.3078 6.37659 15.8752 6.37659ZM1.34088 3.0458C1.21111 3.0458 1.08134 3.17558 1.08134 3.30535V5.55471C1.08134 5.68448 1.21111 5.81425 1.34088 5.81425H15.8752C16.005 5.81425 16.1348 5.68448 16.1348 5.55471V3.30535C16.1348 3.17558 16.005 3.0458 15.8752 3.0458H1.34088Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56494 5.42494C8.04585 5.42494 7.61328 4.99237 7.61328 4.47329C7.61328 3.95421 8.04585 3.52164 8.56494 3.52164C9.08402 3.52164 9.51659 3.95421 9.51659 4.47329C9.51659 4.99237 9.08402 5.42494 8.56494 5.42494ZM8.56494 3.99746C8.30539 3.99746 8.13237 4.21375 8.13237 4.43003C8.13237 4.68958 8.34865 4.8626 8.56494 4.8626C8.78122 4.8626 8.99751 4.64632 8.99751 4.43003C8.99751 4.21375 8.82448 3.99746 8.56494 3.99746Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_1507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 6.53181,
    fill: "currentColor",
    transform: "translate(0 0.2341)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementIcon);
export default __webpack_public_path__ + "static/media/element-icon.09c6c8ee0a0a195415ebd7e485b947b4.svg";
export { ForwardRef as ReactComponent };